import { Link } from "react-router-dom";
import { Facebook, MapPin } from "lucide-react";
import { COMPANY } from "../data";
import { openCookiePreferences } from "./CookieBanner";

const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61592217743131", Icon: Facebook },
  { label: "Google Maps", href: "https://maps.app.goo.gl/TCxM4YF7NboUn7Ar6", Icon: MapPin },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white border-t border-white/10 px-6 md:px-12 py-14">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between gap-8">
        <div>
          <p className="font-serif text-2xl tracking-tight">
            <span style={{ color: "#2B6A8F" }}>VETRO</span> <span className="text-champagne">DESIGN</span> ITALIA
          </p>
          <p className="text-sm text-white/50 font-light mt-3 max-w-sm">{COMPANY.address}</p>
          <div className="flex items-center gap-3 mt-5" data-testid="footer-socials">
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                data-testid={`footer-social-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:border-white/50 hover:bg-white/5 transition-colors"
              >
                <Icon size={18} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-2 text-sm text-white/60 font-light">
          <a href={`mailto:${COMPANY.email}`} className="link-underline w-fit">{COMPANY.email}</a>
          <a href={`tel:${COMPANY.phone}`} className="link-underline w-fit">{COMPANY.phone}</a>
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="link-underline w-fit mt-2">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" data-testid="footer-cookie-link" className="link-underline w-fit">
            Cookie Policy
          </Link>
          <button onClick={openCookiePreferences} data-testid="footer-cookie-prefs" className="link-underline w-fit text-left">
            Preferenze Cookie
          </button>
          <Link to="/admin" data-testid="footer-admin-link" className="link-underline w-fit mt-2 text-white/30">
            Area Riservata
          </Link>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/55 uppercase tracking-wide">
        <p>© {new Date().getFullYear()} VETRO DESIGN ITALIA</p>
        <p>P.IVA {COMPANY.piva} · REA 317787 · Made in Italy</p>
      </div>
    </footer>
  );
};
